var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "omegaup-overlay-popup",
    {
      staticClass: "overlay-popup--wide",
      on: {
        dismiss: function ($event) {
          return _vm.$emit("dismiss")
        },
      },
    },
    [
      _vm.data
        ? _c("div", [
            _c(
              "form",
              {
                staticClass: "modal-form",
                attrs: { "data-run-details-view": "" },
              },
              [
                _vm._t("feedback", null, {
                  feedback: _vm.data.feedback,
                  guid: _vm.data.guid,
                  isAdmin: _vm.data.admin,
                }),
                _c(
                  "div",
                  { staticClass: "source_code" },
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.T.wordsCode))]),
                    _vm.data.source_link
                      ? _c(
                          "a",
                          {
                            attrs: {
                              download: "data.zip",
                              href: _vm.data.source,
                            },
                          },
                          [_vm._v(_vm._s(_vm.T.wordsDownload))]
                        )
                      : _vm._t(
                          "code-view",
                          function () {
                            return [
                              _c("omegaup-arena-feedback-code-view", {
                                attrs: {
                                  language: _vm.language,
                                  value: _vm.source,
                                  "feedback-map": _vm.feedbackMap,
                                  "feedback-thread-map": _vm.feedbackThreadMap,
                                },
                                on: {
                                  "save-feedback-list": (feedbackList) =>
                                    _vm.onSaveFeedbackList(
                                      feedbackList,
                                      _vm.data.guid
                                    ),
                                  "submit-feedback-thread": (feedback) =>
                                    _vm.onSubmitFeedbackThread(
                                      feedback,
                                      _vm.data.guid
                                    ),
                                },
                              }),
                            ]
                          },
                          { guid: _vm.data.guid }
                        ),
                  ],
                  2
                ),
                _vm.data.groups
                  ? _c("div", { staticClass: "cases" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.T.wordsCases))]),
                      _c("div"),
                      _c(
                        "table",
                        { staticClass: "w-100" },
                        [
                          _c("thead", [
                            _c("tr", { staticClass: "text-center" }, [
                              _c("th", [_vm._v(_vm._s(_vm.T.wordsGroup))]),
                              _vm.data.feedback !== "summary"
                                ? _c("th", [_vm._v(_vm._s(_vm.T.wordsCase))])
                                : _vm._e(),
                              _c("th", [_vm._v(_vm._s(_vm.T.wordsVerdict))]),
                              _c("th", { attrs: { colspan: "3" } }, [
                                _vm._v(_vm._s(_vm.T.rankScore)),
                              ]),
                              _c("th", { attrs: { width: "1" } }),
                            ]),
                          ]),
                          _vm._l(_vm.data.groups, function (element) {
                            return _c(
                              "tbody",
                              { key: element.group },
                              [
                                _c(
                                  "tr",
                                  { staticClass: "group border-top" },
                                  [
                                    _c("th", { staticClass: "text-center" }, [
                                      _vm._v(_vm._s(element.group)),
                                    ]),
                                    element.verdict
                                      ? _c(
                                          "th",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(element.verdict) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _c("th", { attrs: { colspan: "2" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-100 h-100 my-0 mx-auto text-center bg-white text-dark rounded",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggle(
                                                    element.group
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm.groupVisible[element.group]
                                                ? _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: [
                                                        "fas",
                                                        "chevron-circle-up",
                                                      ],
                                                    },
                                                  })
                                                : _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: [
                                                        "fas",
                                                        "chevron-circle-down",
                                                      ],
                                                    },
                                                  }),
                                            ],
                                            1
                                          ),
                                        ]),
                                    _c("th", { staticClass: "text-right" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            element.contest_score
                                              ? element.contest_score
                                              : element.score
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    element.max_score
                                      ? [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-center",
                                              attrs: { width: "10" },
                                            },
                                            [_vm._v("/")]
                                          ),
                                          _c("th", [
                                            _vm._v(_vm._s(element.max_score)),
                                          ]),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm.groupVisible[element.group]
                                  ? [
                                      _vm._l(
                                        element.cases,
                                        function (problemCase) {
                                          return [
                                            _c(
                                              "tr",
                                              { key: problemCase.name },
                                              [
                                                _c("td"),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-center",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(problemCase.name)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-center",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        problemCase.verdict
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.contestScore(
                                                            problemCase
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { width: "10" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          problemCase.max_score
                                                            ? "/"
                                                            : ""
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        problemCase.max_score
                                                          ? problemCase.max_score
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm.shouldShowDiffs(
                                              problemCase.name
                                            )
                                              ? [
                                                  _c(
                                                    "tr",
                                                    {
                                                      key: `input-title-${problemCase.name}`,
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            colspan: "6",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.T.wordsInput
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "tr",
                                                    {
                                                      key: `input-${problemCase.name}`,
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            colspan: "6",
                                                          },
                                                        },
                                                        [
                                                          _c("pre", [
                                                            _vm._v(
                                                              "                        "
                                                            ),
                                                            _c("code", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.showDataCase(
                                                                    _vm.data
                                                                      .cases,
                                                                    problemCase.name,
                                                                    "in"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              "\n                      "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "tr",
                                                    {
                                                      key: `diffs-title-${problemCase.name}`,
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            colspan: "6",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.T
                                                                .wordsDifference
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "tr",
                                                    {
                                                      key: `diffs-${problemCase.name}`,
                                                    },
                                                    [
                                                      _vm.data.cases
                                                        ? _c(
                                                            "td",
                                                            {
                                                              attrs: {
                                                                colspan: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "omegaup-arena-diff-view",
                                                                {
                                                                  attrs: {
                                                                    left: _vm
                                                                      .data
                                                                      .cases[
                                                                      problemCase
                                                                        .name
                                                                    ].out,
                                                                    right:
                                                                      _vm.getContestantOutput(
                                                                        _vm.data
                                                                          .cases,
                                                                        problemCase.name
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "empty-table-message",
                                                              attrs: {
                                                                colspan: "6",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.EMPTY_FIELD
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
                _vm.data.compile_error
                  ? _c("div", { staticClass: "compile_error" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.T.wordsCompilerOutput))]),
                      _c("pre", { staticClass: "compile_error" }, [
                        _vm._v("          "),
                        _c("code", {
                          domProps: {
                            textContent: _vm._s(_vm.data.compile_error),
                          },
                        }),
                        _vm._v("\n        "),
                      ]),
                    ])
                  : _vm._e(),
                _vm.data.logs
                  ? _c("div", { staticClass: "logs" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.T.wordsLogs))]),
                      _c("pre", [
                        _vm._v("          "),
                        _c("code", {
                          domProps: { textContent: _vm._s(_vm.data.logs) },
                        }),
                        _vm._v("\n        "),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "download" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.T.wordsDownload))]),
                  _c(
                    "ul",
                    [
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "sourcecode",
                            attrs: {
                              download: _vm.data.source_name,
                              href: _vm.data.source_url,
                            },
                          },
                          [_vm._v(_vm._s(_vm.T.wordsDownloadCode))]
                        ),
                      ]),
                      _vm.data.admin
                        ? [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "output",
                                  attrs: {
                                    href: `/api/run/download/run_alias/${_vm.data.guid}/`,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.T.wordsDownloadOutput))]
                              ),
                            ]),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "details",
                                  attrs: {
                                    href: `/api/run/download/run_alias/${_vm.data.guid}/complete/true/`,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.T.wordsDownloadDetails))]
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm.data.judged_by
                  ? _c("div", { staticClass: "judged_by" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.T.wordsJudgedBy))]),
                      _c("pre", [
                        _vm._v("          "),
                        _c("code", {
                          domProps: { textContent: _vm._s(_vm.data.judged_by) },
                        }),
                        _vm._v("\n        "),
                      ]),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "guid" },
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.T.runGUID))]),
                    _c(
                      "acronym",
                      { attrs: { title: _vm.data.guid, "data-run-guid": "" } },
                      [_c("tt", [_vm._v(_vm._s(_vm.shortGuid))])],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ])
        : _c("div", [
            _c(
              "div",
              {
                staticClass: "spinner-border text-info big",
                attrs: { role: "status" },
              },
              [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }